var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbp1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "matrix(1 0 0 -1 0 32.5)",
    fill: "url(#paint0_linear_5700_810)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9456 24.834V11.4153L16.7589 13.1646H12.1723V9.90065H19.1696V24.834H14.9456Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5700_810",
    x1: 16,
    y1: 24.6667,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2CD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#597B13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbp1);
export default __webpack_public_path__ + "static/media/ebp-1.7938e83bead4c6d5357e4ac253a9ce3d.svg";
export { ForwardRef as ReactComponent };